<template>
  <div class="default-modal is-show" style="display: block;">
    <div class="default-modal__bg js-default-modal-close"></div>
    <div class="default-modal__content l-tutorial" style="width: 970px;" @click="stopEvent()">
      <div class="default-modal__header">
        <a class="default-modal__close js-default-modal-close"  @click="close()"></a>
      </div>
      <div class="default-modal__body">
        <div class="l-headding is-blueline">ログイン認証コード入力画面</div>
        <div class="l-tutorial__canvas">

<div class="instruction-text">
  ログインに使用しているメールアドレス宛にログイン認証コードを送信しました。<br/>
受信したコードを入力して本人確認を行ってください。認証コードの有効期間は5分間です。<br/>

<a href="https://support.roumu-kansa.jp/howto/expert/3105046.html" class="link-arrow" target="_blank" rel="noopener noreferrer">ログイン認証コードについてのヘルプ</a>

</div>

<div class="error" v-if="message.length>0">
{{this.message}}
</div>

          <div class="box-passcode-container">
            <input type="text" maxlength="1" class="box-passcode-input" 
                   @input="handleInput" 
                   @paste="handlePaste"
                   @keydown="handleKeydown" 
                   ref="input0">
            <input type="text" maxlength="1" class="box-passcode-input" 
                   @input="handleInput" 
                   @paste="handlePaste"
                   @keydown="handleKeydown" 
                   ref="input1">
            <input type="text" maxlength="1" class="box-passcode-input" 
                   @input="handleInput" 
                   @paste="handlePaste"
                   @keydown="handleKeydown" 
                   ref="input2">
            <input type="text" maxlength="1" class="box-passcode-input" 
                   @input="handleInput" 
                   @paste="handlePaste"
                   @keydown="handleKeydown" 
                   ref="input3">
            <input type="text" maxlength="1" class="box-passcode-input" 
                   @input="handleInput" 
                   @paste="handlePaste"
                   @keydown="handleKeydown" 
                   ref="input4">
            <input type="text" maxlength="1" class="box-passcode-input" 
                   @input="handleInput" 
                   @paste="handlePaste"
                   @keydown="handleKeydown" 
                   ref="input5">
          </div>

        </div>
        <div class="default-modal__footer">
          <div class="l-btn-center">
            <div class="btn-basic is-primary">
              <button @click="checkPassword()">認証</button>
            </div>
            <div class="btn-basic is-secondary" style="margin-left: 10px;">
              <button @click="resendPassword()" :disabled="isResending || cooldownSeconds > 0">
                {{ cooldownSeconds > 0 ? `再送不可 (${cooldownSeconds}秒)` : '再発行' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      isNotDisplayedTutorial: false,
      message: '',
      isResending: false,
      cooldownSeconds: 0,
      cooldownTimer: null,
    }
  },
  methods: {
    handlePaste(event) {
      // ペーストのデフォルト動作を防止
      event.preventDefault();
      
      // クリップボードからテキストを取得
      let pasteData = (event.clipboardData || window.clipboardData).getData('text');
      
      // 全角数字を半角数字に変換
      pasteData = pasteData.replace(/[０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      
      // 数字以外を除去
      pasteData = pasteData.replace(/[^0-9]/g, '');
      
      // 各入力欄に文字を分配
      const inputs = document.querySelectorAll('.box-passcode-input');
      for (let i = 0; i < Math.min(pasteData.length, inputs.length); i++) {
        inputs[i].value = pasteData[i];
      }
      
      // 最後に入力された欄にフォーカス（または全て入力された場合は最後の欄）
      const lastFilledIndex = Math.min(pasteData.length, inputs.length) - 1;
      if (lastFilledIndex >= 0) {
        inputs[lastFilledIndex].focus();
      }
    },
    handleInput(event) {
      const input = event.target;
      let value = input.value;

      // 全角数字を半角数字に変換
      value = value.replace(/[０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });

      // 数字以外を除去
      value = value.replace(/[^0-9]/g, '');

      // 最初の1文字のみを保持
      if (value.length > 1) {
        value = value.charAt(0);
      }

      input.value = value;

      // 入力があれば次のフィールドにフォーカス
      if (value.length === 1) {
        const inputs = document.querySelectorAll('.box-passcode-input');
        const currentIndex = Array.from(inputs).indexOf(input);
        if (currentIndex < inputs.length - 1) {
          inputs[currentIndex + 1].focus();
        }
      }
    },
    handleKeydown(event) {
      const input = event.target;
      
      // Backspaceキーで前のフィールドに戻る
      if (event.key === 'Backspace' && !input.value) {
        const inputs = document.querySelectorAll('.box-passcode-input');
        const currentIndex = Array.from(inputs).indexOf(input);
        if (currentIndex > 0) {
          inputs[currentIndex - 1].focus();
        }
      }
    },
    checkPassword(){
      this.message = '';
      const inputs = document.querySelectorAll('.box-passcode-input');
      var code = "";
      inputs.forEach((input) => {
        code = code + input.value;
      });

      if ( code.length < 6 ) {
        this.message = '6文字の数値を入力してください'; return;
      }

      // 全角数字を半角数字に変換
      code = code.replace(/[０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });

      var pattern = /^\d*$/;
      if ( !pattern.test(code) ) {
        this.message = '数値を入力してください'; return;
      }

      this.$emit('onetime-password-input',{code: code});
    },
    showError(errorMessage) {
      this.message = errorMessage;
    },
    async resendPassword() {
      this.isResending = true;
      this.message = '';
      try {
        await this.$axios.get('/ld/sanctum/csrf-cookie');
        await this.$axios.post('/ld/api/user/resendOnetimePassword', { 
          userId: this.userId 
        });
        this.$toast.info('ワンタイムパスワードを再送信しました。メールをご確認ください。');
        // 入力欄をクリア
        const inputs = document.querySelectorAll('.box-passcode-input');
        inputs.forEach((input) => {
          input.value = '';
        });
        if (inputs.length > 0) {
          inputs[0].focus();
        }
        // 60秒のクールダウンを開始
        this.startCooldown();
      } catch (error) {
        console.error('Resend error:', error);
        this.message = 'ワンタイムパスワードの再発行に失敗しました。';
        this.$toast.error('ワンタイムパスワードの再発行に失敗しました。');
      } finally {
        this.isResending = false;
      }
    },
    startCooldown() {
      // 既存のタイマーをクリア
      if (this.cooldownTimer) {
        clearInterval(this.cooldownTimer);
      }
      // 60秒のカウントダウンを開始
      this.cooldownSeconds = 60;
      this.cooldownTimer = setInterval(() => {
        this.cooldownSeconds--;
        if (this.cooldownSeconds <= 0) {
          clearInterval(this.cooldownTimer);
          this.cooldownTimer = null;
        }
      }, 1000);
    },
    close() {
      const inputs = document.querySelectorAll('.box-passcode-input');
      inputs.forEach((input) => {
        input.value = '';
      });
      this.message = '';
      // タイマーをクリア
      if (this.cooldownTimer) {
        clearInterval(this.cooldownTimer);
        this.cooldownTimer = null;
        this.cooldownSeconds = 0;
      }
      this.$emit('close-onetime-modal');  
    },
    stopEvent() {
      event.stopPropagation()
    }
  },
  beforeDestroy() {
    // コンポーネント破棄時にタイマーをクリーンアップ
    if (this.cooldownTimer) {
      clearInterval(this.cooldownTimer);
    }
  },
}
</script>


<style scoped>
/* 説明文のスタイル */
.instruction-text {
  text-align: center;
  font-size: 14px;
  color: #333;
  margin: 20px auto 10px;
  line-height: 1.6;
}

/* 外側のコンテナ */
.box-passcode-container {
  display: flex;
  justify-content: center; /* 中央揃え */
  gap: 10px; /* 入力ボックス間の間隔 */
  margin: 50px auto;
}

/* 個々の入力ボックス */
.box-passcode-input {
  width: 50px;
  height: 50px;
  font-size: 24px;
  text-align: center;
  border: 2px solid #ccc;
  border-radius: 8px;
  box-sizing: border-box;
  caret-color: transparent; /* カーソルを非表示 */
  transition: border-color 0.3s ease;
}

/* 入力ボックスにフォーカスした時のスタイル */
.box-passcode-input:focus {
  outline: none;
  border-color: #007bff; /* 青色に変化 */
}

</style>